import alak_modak from "../assets/pdf/Alak-Modak.pdf";

export const headerData = {
  name: "Alak Modak",
  title: "Software Engineer",
  desciption:
    "Innovative Software Engineer with 3+ years of experience building scalable full-stack applications and AI-powered solutions. Specialized in cloud architecture, LLM integration, and performance optimization. Passionate about leveraging cutting-edge technologies to solve complex problems and deliver exceptional user experiences.",
  image:
    "https://avatars.githubusercontent.com/u/93376849?s=400&u=77a2727dc185d0b0b4da0ac1101a2f02100f9d05&v=4",
  resumePdf: alak_modak,
};
